import { render, staticRenderFns } from "./TestPackageGroupForm.vue?vue&type=template&id=3f9be048"
import script from "./TestPackageGroupForm.vue?vue&type=script&lang=js"
export * from "./TestPackageGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports